import COMMON_LABELS from "../../../../common/locale/zh_CN";

export const LABELS: Record<string, string> = {
    ...COMMON_LABELS,
};

export default LABELS;
